import {
  GET_CIVILCONTRACT,
  GET_CIVILCONTRACT_SUCCESS,
  GET_CIVILCONTRACT_FAIL,
  DELETE_CIVILCONTRACT,
  DELETE_CIVILCONTRACT_SUCCESS,
  DELETE_CIVILCONTRACT_FAIL,
  UPDATE_CIVILCONTRACT,
  UPDATE_CIVILCONTRACT_SUCCESS,
  UPDATE_CIVILCONTRACT_FAIL,
  ADD_NEW_CIVILCONTRACT,
  ADD_CIVILCONTRACT_SUCCESS,
  ADD_CIVILCONTRACT_FAIL,
  CIVILCONTRACT_LOADING,
  CIVILCONTRACT_RESET
} from "./actionType";

export const resetCivilContractState = (actionType) => ({
  type: CIVILCONTRACT_RESET,
  payload: { actionType },
});

export const getCivilContractSuccess = (actionType, data) => ({
  type: GET_CIVILCONTRACT_SUCCESS,
  payload: { actionType, data },
});

export const getCivilContractFail = (actionType, error) => ({
  type: GET_CIVILCONTRACT_FAIL,
  payload: { actionType, error },
});

export const getCivilContract = data => ({
  type: GET_CIVILCONTRACT,
  payload: data,
});

export const getCivilContractLoading = () => ({
  type: CIVILCONTRACT_LOADING
});

export const deleteCivilContract = data => ({
  type: DELETE_CIVILCONTRACT,
  payload: data,
});

export const deleteCivilContractSuccess = data => ({
  type: DELETE_CIVILCONTRACT_SUCCESS,
  payload: data,
});

export const deleteCivilContractFail = error => ({
  type: DELETE_CIVILCONTRACT_FAIL,
  payload: error,
});

export const updateCivilContract = data => ({
  type: UPDATE_CIVILCONTRACT,
  payload: data,
});

export const updateCivilContractFail = error => ({
  type: UPDATE_CIVILCONTRACT_FAIL,
  payload: error,
});

export const updateCivilContractSuccess = data => ({
  type: UPDATE_CIVILCONTRACT_SUCCESS,
  payload: data,
});

export const addNewCivilContract = data => ({
  type: ADD_NEW_CIVILCONTRACT,
  payload: data,
});

export const addCivilContractSuccess = data => ({
  type: ADD_CIVILCONTRACT_SUCCESS,
  payload: data,
});

export const addCivilContractFail = error => ({
  type: ADD_CIVILCONTRACT_FAIL,
  payload: error,
});